import { render, staticRenderFns } from "./AdminContractSpecificDashboard.vue?vue&type=template&id=56b0eb8d&scoped=true"
import script from "./AdminContractSpecificDashboard.vue?vue&type=script&lang=js"
export * from "./AdminContractSpecificDashboard.vue?vue&type=script&lang=js"
import style0 from "./AdminContractSpecificDashboard.vue?vue&type=style&index=0&id=56b0eb8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b0eb8d",
  null
  
)

export default component.exports